import { Navigate, useParams } from 'react-router';

/**
 * An event's attendees used to live at /events/:id (and its forms at /events/:id/:tab). They are
 * on the Attendees page now, so an old link lands there on the same event.
 */
export default function EventPage() {
  const { eventId = '' } = useParams();
  return <Navigate to={`/events/attendees?event=${encodeURIComponent(eventId)}`} replace />;
}
